import React, { useEffect } from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Zoom from "react-medium-image-zoom"
import "react-medium-image-zoom/dist/styles.css"


export function NewTab () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="inline-block align-baseline text-blue-300 group-hover:text-blue-600 transition-all" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
        </svg>
    )
}

export function LinkExt ({to, children}) {
    return (
        <a href={to} target="_blank" rel="noreferrer" className="group text-blue-600 border-b border-blue-200 hover:border-blue-600 transition-all">
            {children} <NewTab />
        </a>
    )
}

export function LinkInt ({to, children}) {
    return (
        <Link to={to} className="text-blue-600 border-b border-blue-200 hover:border-blue-600 transition-all">
            {children}
        </Link>
    )
}

export function Cols ({num=4, children}) {
    return (
        <div className={`columns-1 md:columns-1 lg:columns-4 gap-8`}>
            {children}
        </div>
    )
}

export function Intro({children}) {
    return (
        <div className="text-xl 2xl:text-2xl flex flex-col gap-5">
            {children}
        </div>
    )
}

export function BulletList({children}) {
    return (
        <ul className="2xl:text-xl pl-5 space-y-5 list-['—'] mb-7">
            {children}
        </ul>
    )
}

export function B({children}) {
    return (
        <li className="pl-2">
            {children}
        </li>
    )
}

export function InlineList({children}) {
    return (
        <ul className="mt-1 flex flex-wrap gap-2 text-base">
            {children}
        </ul>
    )
}

export function I({last, children}) {
    return (
        <li className={`${last ? "" : "after:content-[',']"}`}>
            {children}
        </li>
    )
}

export function Feature({icon, children}) {
    return (
        <div className="break-inside-avoid-column flex flex-col gap-2 mb-8">
            <span className="text-6xl">{icon}</span>
            {children}
        </div>
    )
}

export function Tags({size, children}) {
    switch (size) {
        case "sm":
            size = "text-base"
            break;
        default:
            size = ""
    }
    return (
        <ul className={"flex flex-wrap gap-2 " + size}>
            {children}
        </ul>
    )
}

export function Tag({color, children}) {
    switch (color) {
        case "green":
            color = "bg-green-100"
            break;
        case "amber":
            color = "bg-amber-100"
            break;
        default:
            color = "bg-blue-100"
    }
    return (
        <li className={"py-2 px-4 rounded-md " + color}>
            {children}
        </li>
    )
}

export function GoToTop() {
  const [scrolled, setScrolled] = React.useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    })
  }, []);
  
  
  return (
    scrolled && <li>
        <a className="cursor-pointer text-gray-300 hover:text-gray-400 transition-all" onClick={() => {window.scrollTo({top: 0, behavior: "smooth"})}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"/>
            </svg>
        </a>
    </li>
  )
}

export function Media({mediaName, mediaNode, name, className}) {
    const mediaType = mediaName.split(".")[1] === "mp4" ? "video" : "image";
  return (
    mediaType === "video" ?
    <video loop="true" controls muted className={"rounded-sm shadow-lg/20 " + className}>
      <source src={mediaNode.publicURL} type="video/mp4" />
    </video>
    :
    <Zoom>
        <GatsbyImage image={getImage(mediaNode)} alt={name} className={"rounded-sm shadow-lg/20"} />
    </Zoom>
  )
}

export function Work({name, imageNames, children, layout}) {
    const data = useStaticQuery(graphql`
        query {
            allFile(filter: {ext: {in: [".png",".mp4"]}}) {
                nodes {
                    name
                    publicURL
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: BLURRED,
                        )
                    }
                }
            }
        }
    `)
    const imageNodes = imageNames.map(imageName => {
        let imageNode = data.allFile.nodes.find(
            node => node.name === imageName?.split(".")[0]
        )
        return imageNode
    });

    var outerContainerStyle = "";
    var featureStyle = "";
    var innerContainerStyle = "flex gap-6 ";
    var imageGroupStyle = "";
    var descStyle = "space-y-2 ";
    const layoutSpecs = layout.split("-");
    const layoutType = layoutSpecs[0];
    const descPos = layoutSpecs[1];
    const descAlignmt = layoutSpecs[2];
    const stacking = layoutSpecs.length > 3 ? layoutSpecs[3] : null;
    const gap = layoutSpecs.length > 4 ? layoutSpecs[4] : null;

    if (descPos === "t" || descPos === "b") {
        if (layoutType === "leftfeature" || layoutType === "rightfeature") {
            innerContainerStyle += "lg:flex-col ";
        } else {
            innerContainerStyle += "flex-col ";
        }
    }

    switch (layoutType) {
        case "mobile":
            imageGroupStyle += "w-1/2 max-w-60 ";
            descStyle += "w-1/2 ";
            break;
        case "web":
            if (descPos === "l" || descPos === "r") {
                innerContainerStyle += "flex-col md:flex-row ";
            }
            imageGroupStyle += "min-w-2/3 "
            break;
        case "topfeature":
            outerContainerStyle += "flex flex-col gap-6 ";
            innerContainerStyle += "flex-col md:flex-row ";
            break;
        case "rightfeature":
            innerContainerStyle += "md:order-first items-end ";
        case "leftfeature":
            outerContainerStyle += "flex flex-col lg:flex-row gap-6 ";
            featureStyle += "lg:max-w-2/3"
            innerContainerStyle += "flex-col md:flex-row lg:max-w-1/3 ";
            imageGroupStyle += "lg:max-w-2/3 ";
            break;
        case "grid":
            imageGroupStyle += "grid grid-cols-2 grid-rows-2 gap-6 ";
            break;
    }

    switch (descPos) {
        case "t":
            descStyle += "order-last md:order-first ";
            break;
        case "l":
            descStyle += "order-first text-right ml-auto ";
            break;
    }

    switch (descAlignmt) {
        case "b":
            innerContainerStyle += "items-end ";
            break;
        case "r":
            descStyle += "text-right ";
            break;
    }

    switch (stacking) {
        case "1/2":
            outerContainerStyle += "lg:max-w-1/2 "
            break;
        case "1/3":
            outerContainerStyle += "lg:max-w-1/3 "
            break;
        case "2/3":
            outerContainerStyle += "lg:max-w-2/3 "
            break;
    }
    
    switch (gap) {
        case "gapbefore":
            outerContainerStyle += "lg:pl-24 "
            break;
    }

    return (
        <div className={outerContainerStyle}>
            {(layoutType === "topfeature" || layoutType === "leftfeature" || layoutType === "rightfeature")
                &&
                <Media mediaName={imageNames[0]} mediaNode={imageNodes[0]} name={name} className={featureStyle} />
            }
            <div className={innerContainerStyle}>
                <div className={imageGroupStyle}>
                    {imageNodes.map((imageNode, i) => (
                        ((layoutType !== "topfeature" && layoutType !== "leftfeature" && layoutType !== "rightfeature") || i > 0)
                        &&
                        <Media mediaName={imageNames[i]} mediaNode={imageNode} name={name} />
                        
                    ))}
                </div>
                <div className={descStyle}>
                    <h3>{name}</h3>
                    <div className="text-sm space-y-2">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}